import * as React from 'preact/compat'
import cn from 'classnames'
import Api from '../../../api'
import BackButton from '../BackButton'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'
import formCss from '../../../../css/form.pcss.json'
import buttonsCss from '../../../../css/buttons.pcss.json'
import { loadStylesheet } from '../../../common/helpers'

interface StateTypes {
  isSending: boolean,
  stage: 1 | 2 | 3,
  error: string | null,
  lastSent: string | null
}

export default class PageNewPassword extends React.Component<DialogComponentPropTypes, StateTypes> {
  state: StateTypes = {
    isSending: false,
    stage: 1,
    error: null,
    lastSent: null
  }

  codeInputElement = React.createRef<HTMLInputElement>()

  public componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  public componentDidMount() {
    if (this.codeInputElement.current) {
      this.codeInputElement.current.focus()
    }
  }

  toLogin = () => this.props.switchPage('login')
  toPasswordReset = () => this.props.switchPage('restore-password')

  sendCode = (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData(event.currentTarget)

    this.setState({
      isSending: true,
      error: null,
      lastSent: formData.get('code').toString()
    })

    Api.post({
      url: 'auth/verify-reset-code',
      body: formData
    })
      .then(result => {
        if (!result.success) {
          this.setState({
            isSending: false,
            error: result.error
          })
          return
        }
        this.setState({
          isSending: false,
          stage: 2
        })
      })
      .catch(() => {
        this.setState({
          isSending: false,
          error: 'Произошла непредвиденная ошибка.'
        })
      })
  }

  codeInput = (event: React.TargetedEvent<HTMLInputElement>) => {
    const { lastSent } = this.state
    const input = event.currentTarget as HTMLInputElement
    input.value = input.value.trim()

    if (input.value.length >= 10 && input.value !== lastSent) {
      input.closest('form').requestSubmit()
    }
  }

  get id() {
    if (this.props.authInfo) {
      return this.props.authInfo.id
    }

    return window.userId ?? null
  }

  get code() {
    return window.activationCode ?? null
  }

  render() {
    const { stage, isSending, error } = this.state

    if (stage === 1) {
      return <>
        <BackButton goBack={this.toPasswordReset}/>
        <div className={styles['auth-header']}>
          <h1>Восстановление пароля</h1>
        </div>
        <form onSubmit={this.sendCode}>
          <input type="hidden" name="id" value={this.id || 0}/>
          <input
            type="text"
            name="code"
            ref={this.codeInputElement}
            placeholder="Код восстановления пароля"
            disabled={isSending}
            onInput={this.codeInput}
            onFocus={this.codeInput}
            required
            minLength={10}
            maxLength={10}
            value={this.code}
            className={cn(formCss['input'], {
              [formCss['input-error']]: error
            })}
            autocomplete="one-time-code"
          />
          <p
            className={formCss['error-hint']}
            style={{ opacity: error ? 1 : 0, width: '100%' }}
          >{error || 'Нет ошибок'}</p>
        </form>
      </>
    }
    return <>
      <div className={styles['auth-header']}>
        <h1>Всё получилось!</h1>
      </div>
      <div style='display: flex; flex-direction: column; align-items: center;'>
        <p style="text-align: center; margin-bottom: 40px;">
          Новый пароль уже выслан на твою почту.<br/>
          Используя его ты можешь зайти на сайт.
        </p>
        <button
          onClick={this.toLogin}
          className={buttonsCss['primary']}
          style='min-width: 170px'
        >
          Войти
        </button>
      </div>
    </>
  }
}
